
export default function Footer() {
  return (
    <footer className="bg-green-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              株式会社MELM
            </h4>
            <p className="text-green-100 mb-4 leading-relaxed">
              美容の可能性を広げ、お客様の美しさを引き出すことを使命とする美容商材の専門企業です。
            </p>
            
          </div>

          <div>
            <h5 className="text-lg font-bold mb-4">
              <strong>商品カテゴリ</strong>
            </h5>
            <ul className="space-y-2">
              <li><a href="#products" className="text-green-100 hover:text-yellow-300 transition-colors cursor-pointer">スキンケア商品</a></li>
              <li><a href="#products" className="text-green-100 hover:text-yellow-300 transition-colors cursor-pointer">メイクアップ商品</a></li>
              <li><a href="#products" className="text-green-100 hover:text-yellow-300 transition-colors cursor-pointer">ヘアケア商品</a></li>
              <li><a href="#products" className="text-green-100 hover:text-yellow-300 transition-colors cursor-pointer">ネイル商品</a></li>
              <li><a href="#products" className="text-green-100 hover:text-yellow-300 transition-colors cursor-pointer">美容機器</a></li>
              <li><a href="#products" className="text-green-100 hover:text-yellow-300 transition-colors cursor-pointer">業務用商材</a></li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-bold mb-4">
              <strong>サービス</strong>
            </h5>
            <ul className="space-y-2">
              <li><a href="#services" className="text-green-100 hover:text-yellow-300 transition-colors cursor-pointer">商品企画・開発</a></li>
              <li><a href="#services" className="text-green-100 hover:text-yellow-300 transition-colors cursor-pointer">製造・品質管理</a></li>
              <li><a href="#services" className="text-green-100 hover:text-yellow-300 transition-colors cursor-pointer">卸売・小売販売</a></li>
              <li><a href="#services" className="text-green-100 hover:text-yellow-300 transition-colors cursor-pointer">通信販売事業</a></li>
              <li><a href="#services" className="text-green-100 hover:text-yellow-300 transition-colors cursor-pointer">アフターサポート</a></li>
              <li><a href="#services" className="text-green-100 hover:text-yellow-300 transition-colors cursor-pointer">技術指導・研修</a></li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-bold mb-4">
              <strong>会社情報</strong>
            </h5>
            <div className="space-y-3 text-green-100">
              <div className="flex items-start space-x-2">
                <i className="ri-map-pin-line mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-sm">
                    〒546-0043<br />
                    大阪府大阪市東住吉区駒川3-27-39<br />
                    プレジオールKOMAGAWA 204
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-user-line"></i>
                <p className="text-sm">宮下　亜希</p>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line"></i>
                <p className="text-sm">080-2466-3126 / 050-8894-7919</p>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line"></i>
                <p className="text-sm break-all">accounting@melm-inc.com</p>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-time-line"></i>
                <p className="text-sm">平日 9:00〜18:00</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-green-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-green-100 text-sm mb-4 md:mb-0">
              &copy; 2025 株式会社MELM. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="/privacy" className="text-green-100 hover:text-yellow-300 transition-colors text-sm cursor-pointer">
                プライバシーポリシー
              </a>
              
              
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
